var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-interaction pl-2 pr-2"},[_c('ComponentTopHeader',{on:{"onBack":_vm.goBack}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('iframe',{attrs:{"src":"http://111.10.70.56:3398/website","width":"100%","height":"100%"}})])
}]

export { render, staticRenderFns }